<template>
  <div>
    <div class="service">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="team">
        <div class="module">
          <div class="title">我们的团队</div>
          <div class="list">
            <div>
              <div class="title">经验丰富</div>
              <div class="p">团队核心成员拥有15年以上GIS/图形图像渲染相关专业产品研发和项目实施经验</div>
            </div>
            <div>
              <div class="title">专业性强</div>
              <div
                class="p"
              >团队核心成员大都国内一流高校和科研机构相关专业班科出身，或者拥有多年国内外领先的GIS公司工作经历。具有从底层产品研发到上层应用定制开发多层次的知识储备</div>
            </div>
            <div>
              <div class="title">执行力强</div>
              <div class="p">团队核心成员拥有少则3年多则近10年的产品开发和项目实施协作磨合历程，团队成熟稳定，执行力强</div>
            </div>
          </div>
        </div>
      </div>
      <div class="we">
        <div class="module">
          <div class="title">我们的服务</div>
          <div class="list">
            <div :class="{active:weIndex==0}" @click="check(0)">理念</div>
            <div :class="{active:weIndex==1}" @click="check(1)">体系</div>
          </div>
          <div class="box" :class="{active:weIndex==0}">
            <div class="title">以用户为中心</div>
            <div
              class="p"
            >我们在软件系统计咨询过程中，秉承“以用户为中心”的理念——即在系统的每一个技术选型，每一个功能模块的设计过程当中，都把用户作为考虑基点，围绕用户需求对来优化系统的技术方案和交互页面，而不是一味地强迫用户改变他们的使用习惯来适应软件开发者的想法。</div>
          </div>
          <div class="box" :class="{active:weIndex==1}">
            <div class="title">项目专理体系</div>
            <div
              class="p"
            >在项目咨询、设计、实施过程中，除了遵循成熟的项目管理规程，我们建立起了一套独特地一对一服务体系，称之为“项目专理”体系。针对每个用户每个项目，我们都配套一个专职“项目专理”。所谓项目专理，其责任为对该项目和用户全权负责，身兼项目经理、销售经理等多个角色的责任，为用户提供一门式对接服务，从而大大提升项目实施效率、提升用户服务体验，是项目实施扁平化管理的独创性体系。</div>
          </div>
        </div>
      </div>
      <div class="process">
        <div class="module">
          <div class="title">服务流程</div>
          <div class="list">
            <div>
              <div></div>
              <div></div>
              <span>1</span>
              <p>技术选型</p>
            </div>
            <div>
              <div></div>
              <div></div>
              <span>2</span>
              <p>建设方案</p>
            </div>
            <div>
              <div></div>
              <div></div>
              <span>3</span>
              <p>空间信息可视化分析设计</p>
            </div>
            <div>
              <div></div>
              <div></div>
              <span>4</span>
              <p>系统交互设计</p>
            </div>
            <div>
              <div></div>
              <div></div>
              <span>5</span>
              <p>系统视觉设计</p>
            </div>
          </div>
          <div class="btn" v-jump="'/process'">详细服务流程</div>
        </div>
      </div>
    </div>
    <div class="mobile-service">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="service-content">
        <div class="mobile-team">
          <div class="team-title">我们的团队</div>
          <div class="team-item">
            <div class="image">
              <img src="../assets/images/service/team_img1.png" alt="">
              <span>经验丰富</span>
            </div>
            <p>团队核心成员拥有15年以上GIS/图形图像渲染相关专业产品研发和项目实施经验</p>
          </div>
          <div class="team-item">
            <div class="image">
              <img src="../assets/images/service/team_img2.png" alt="">
              <span>专业性强</span>
            </div>
            <p>团队核心成员大都国内一流高校和科研机构相关专业班科出身，或者拥有多年国内外领先的GIS公司工作经历。具有从底层产品研发到上层应用定制开发多层次的知识储备</p>
          </div>
          <div class="team-item">
            <div class="image">
              <img src="../assets/images/service/team_img3.png" alt="">
              <span>执行力强</span>
            </div>
            <p>团队核心成员拥有15年以上GIS/团队核心成员拥有少则3年多则近10年的产品开发和项目实施协作磨合历程，团队成熟稳定，执行力强</p>
          </div>
        </div>
        <div class="our-service">
          <div class="our-title">我们的服务</div>
          <div class="our-content">
            <el-tabs v-model="activeName">
              <el-tab-pane label="理念" name="first">
                <div class="card">
                  <p>以用户为中心</p>
                  <span>我们在软件系统计咨询过程中，秉承“以用户为中心”的理念——即在系统的每一个技术选型，每一个功能模块的设计过程当中，都把用户作为考虑基点，围绕用户需求对来优化系统的技术方案和交互页面，而不是一味地强迫用户改变他们的使用习惯来适应软件开发者的想法。</span>
                </div>
              </el-tab-pane>
              <el-tab-pane label="体系" name="second">
                <div class="card">
                  <p>项目专理体系</p>
                  <span>在项目咨询、设计、实施过程中，除了遵循成熟的项目管理规程，我们建立起了一套独特地一对一服务体系，称之为“项目专理”体系。针对每个用户每个项目，我们都配套一个专职“项目专理”。所谓项目专理，其责任为对该项目和用户全权负责，身兼项目经理、销售经理等多个角色的责任，为用户提供一门式对接服务，从而大大提升项目实施效率、提升用户服务体验，是项目实施扁平化管理的独创性体系。</span>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="mobile-process">
          <div class="process-title">服务流程</div>
          <div class="process-content">
            <!-- <el-carousel indicator-position="outside">
              <el-carousel-item>
                <div class="swiper">
                  <div class="border"></div>
                  <img src="../assets/images/service/service1.jpg" alt="">
                  <div class="number">1</div>
                  <p>技术选型</p>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="swiper">
                  <div class="border"></div>
                  <img src="../assets/images/service/service2.jpg" alt="">
                  <div class="number">2</div>
                  <p>建设方案</p>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="swiper">
                  <div class="border"></div>
                  <img src="../assets/images/service/service3.jpg" alt="">
                  <div class="number">3</div>
                  <p>空间信息可视化分析设计</p>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="swiper">
                  <div class="border"></div>
                  <img src="../assets/images/service/service4.jpg" alt="">
                  <div class="number">4</div>
                  <p>系统交互设计</p>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="swiper">
                  <div class="border"></div>
                  <img src="../assets/images/service/service5.jpg" alt="">
                  <div class="number">5</div>
                  <p>系统视觉设计</p>
                </div>
              </el-carousel-item>
            </el-carousel> -->
            <div class="top">
              <div class="swiper">
                <div class="border"></div>
                <img src="../assets/images/service/service1.jpg" alt="">
                <div class="number">1</div>
                <p>技术选型</p>
              </div>
              <img src="../assets/images/service/right.png" style="width: 3.2rem;" alt="">
              <div class="swiper">
                <div class="border"></div>
                <img src="../assets/images/service/service2.jpg" alt="">
                <div class="number">2</div>
                <p>建设方案</p>
              </div>
            </div>
            <div class="center">
              <img src="../assets/images/service/down.png"  alt="">
            </div>
            <div class="top">
              <div class="swiper">
                <div class="border"></div>
                <img src="../assets/images/service/service3.jpg" alt="">
                <div class="number">4</div>
                <p>系统交互设计</p>
              </div>
              <img src="../assets/images/service/left.png" style="width: 4rem;" alt="">
              <div class="swiper">
                <div class="border"></div>
                <img src="../assets/images/service/service4.jpg" alt="">
                <div class="number">3</div>
                <p>空间信息可视化分析设计</p>
              </div>
            </div>
            <div class="center2">
              <img src="../assets/images/service/down.png"  alt="">
            </div>
            <div class="top">
              <div class="swiper">
                <div class="border"></div>
                <img src="../assets/images/service/service5.jpg" alt="">
                <div class="number">5</div>
                <p>系统视觉设计</p>
              </div>
              <div class="btn" v-jump="'/process'">详细服务流程 >></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Service",
  metaInfo: {
    title: "专业的管家式项目咨询和开发实施服务体系-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "三维可视化项目服务,三维项目实施流程,管家式服务"
      },
      {
        name: "description",
        content:
          "臻图信息依托多年的产品研发和项目实施经验,建立了完备的软件系统设计咨询服务体系,力争成为业内服务最好的智慧城市信息可视化服务企业。"
      }
    ]
  },
  data() {
    return {
      activeName: 'first',
      bannerData: {
        title: "服务中心",
        p:
          "臻图信息凭借多年的项目经验，建立了完备的软件系统设计咨询服务体系，根据我们在实践中总结出的一整套设计流程、方法和工具，磨炼出了一个专业默契的团队。为用户提供空间信息可视化领域项目系统的需求分析、技术方案设计、视觉交互设计、实施规划等服务。为用户专属打造精准、有效的高品质方案。"
      },
      weIndex: 0
    };
  },
  methods: {
    check: function(index) {
      this.weIndex = index;
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/service/banner.jpg");
}
.service {
  .team .title,
  .we .title,
  .process .title {
    color: #3a3a3a;
    font-size: 38px;
    text-align: center;
  }
  .team {
    padding: 100px 0;
    .list {
      margin-top: 40px;
      display: flex;
      > div {
        display: inline-block;
        width: 382px;
        height: 338px;
        box-sizing: border-box;
        border: 1px solid #dddddd;
        margin-right: 21px;
        padding: 0 55px;
        box-sizing: border-box;
        overflow: hidden;
        .title {
          margin: 128px 0 10px 0;
          color: #4b4b4b;
          font-size: 20px;
        }
        .p {
          font-size: 16px;
          color: rgba(124, 124, 124, 1);
          line-height: 24px;
        }
        &:last-child {
          margin-right: 0;
        }
        &:nth-child(1) {
          background: url("../assets/images/service/team_img1.png") no-repeat
            top 50px center;
          background-size: 52px 57px;
        }
        &:nth-child(2) {
          background: url("../assets/images/service/team_img2.png") no-repeat
            top 50px center;
          background-size: 54px 54px;
        }
        &:nth-child(3) {
          background: url("../assets/images/service/team_img3.png") no-repeat
            top 50px center;
          background-size: 56px 61px;
        }
      }
    }
  }
  .we {
    padding-top: 40px;
    background: #f8f8f8;
    overflow: hidden;
    .module {
      position: relative;
    }
    .list {
      width: 300px;
      font-size: 20px;
      color: #3a3a3a;
      height: 380px;
      margin-top: 60px;
      > div {
        padding: 20px;
        cursor: pointer;
        &:first-child {
          border-bottom: 2px solid @baseColor;
        }
        &.active {
          color: @baseColor;
        }
      }
    }
    .box {
      position: absolute;
      top: 666px;
      height: 300px;
      width: 688px;
      right: 0;
      background: url("../assets/images/service/service_bg.png") no-repeat
        center center/cover;
      padding: 0 95px;
      box-sizing: border-box;
      transition: top 0.4s linear;
      .title {
        margin: 50px 0 20px 0;
        color: #4b4b4b;
        font-size: 20px;
      }
      .p {
        font-size: 16px;
        color: rgba(124, 124, 124, 1);
        line-height: 32px;
      }
      &.active {
        top: 123px;
      }
    }
  }
  .process {
    padding: 100px 0 150px 0;
    .list {
      font-size: 0;
      margin-top: 80px;
      > div {
        width: 220px;
        height: 160px;
        display: inline-block;
        position: relative;
        margin-right: 22px;
        &:last-child {
          margin-right: 0;
        }
        &:nth-child(1) {
          div:nth-child(2) {
            background: url("../assets/images/service/service1.jpg") no-repeat
              center center / 100% 100%;
          }
        }
        &:nth-child(2) {
          div:nth-child(2) {
            background: url("../assets/images/service/service2.jpg") no-repeat
              center center / 100% 100%;
          }
        }
        &:nth-child(3) {
          div:nth-child(2) {
            background: url("../assets/images/service/service3.jpg") no-repeat
              center center / 100% 100%;
          }
        }
        &:nth-child(4) {
          div:nth-child(2) {
            background: url("../assets/images/service/service4.jpg") no-repeat
              center center / 100% 100%;
          }
        }
        &:nth-child(5) {
          div:nth-child(2) {
            background: url("../assets/images/service/service5.jpg") no-repeat
              center center / 100% 100%;
          }
        }
        > div:nth-child(1) {
          border: 1px solid #979797;
          width: 200px;
          height: 140px;
          box-sizing: border-box;
        }
        > div:nth-child(2) {
          width: 200px;
          height: 140px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
        > span {
          color: #4a4a4a;
          font-size: 30px;
          position: absolute;
          top: -18px;
          left: 4px;
          line-height: 30px;
        }
        > p {
          font-size: 20px;
          color: rgba(75, 75, 75, 1);
          margin-top: 40px;
        }
      }
    }
    .btn {
      width: 156px;
      height: 48px;
      border-radius: 24px;
      border: 1px solid rgba(124, 124, 124, 1);
      font-size: 18px;
      color: rgba(75, 75, 75, 1);
      line-height: 48px;
      text-align: center;
      margin: 80px auto 0 auto;
      cursor: pointer;
    }
  }
}
.mobile-service {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/service/banner.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .service-content {
    width: 100%;
    .mobile-team {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem 1.5rem;
      .team-title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        text-align: center;
        color: #333333;
      }
      .team-item {
        margin-top: 2rem;
        border: 1px solid #EBEBEB;
        border-radius: 5px;
        width: 100%;
        box-sizing: border-box;
        padding: 2rem;
        color: #333333;
        .image {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 2rem;
            height: 2rem;
            object-fit: contain;
            margin-right: 1rem;
          }
          >span {
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
          }
        }
        >p {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          text-indent: 2em;
        }
      }
    }
    .our-service {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem 1.5rem;
      background: #F8F8F8;
      .our-title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        text-align: center;
        color: #333333;
      }
      .our-content {
        width: 100%;
        .card {
          width: 100%;
          height: 15rem;
          background-image: url('../assets/images/service/service_bg.png');
          background-repeat: no-repeat;
          background-size: contain;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          padding: 0 2rem;
          color: #3a3a3a;
          >p {
            font-size: 1.4rem;
            font-weight: bold;
            line-height: 2rem;
            text-align: center;
            margin: 0;
          }
          >span {
            font-size: 1rem;
            font-weight: 350;
            line-height: 1.5rem;
            margin-top: 1rem;
          }
        }
      }
    }
    .mobile-process {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem 1.5rem;
      .process-title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        text-align: center;
        color: #333333;
      }
      .process-content {
        width: 100%;
        .top {
          width: 100%;
          height: 13rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .btn {
            align-self: flex-end;
            width: 11.5rem;
            height: 3.2rem;
            border-radius: 2rem;
            opacity: 1;
            background: #3C80E8;
            color: #fff;
            font-size: 1.2rem;
            font-weight: 350;
            line-height: 3.2rem;
            text-align: center;
          }
        }
        .center {
          width: 100%;
          height: 4rem;
          display: flex;
          justify-content: flex-end;
          >img{
            height: 100%;
            object-fit: contain;
            margin-right: 4rem;
          }
        }
        .center2 {
          width: 100%;
          height: 3.2rem;
          display: flex;
          >img{
            height: 100%;
            object-fit: contain;
            margin-left: 4rem;
          }
        }
        .swiper {
          width: 13rem;
          box-sizing: border-box;
          padding: 1rem;
          display: inline-block;
          position: relative;
          height: 13rem;
          .border {
            border: 1px solid #333333;
            width: 10rem;
            height: 7rem;
          }
          >img {
            position: absolute;
            top: 18%;
            left: 18%;
            width: 10rem;
            height: 7rem;
          }
          .number {
            position: absolute;
            top: 0rem;
            left: 2rem;
            font-size: 1.8rem;
          }
          >p {
            width: 100%;
            text-align: center;
            margin-top: 1.5rem;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
  
}
/deep/.el-carousel__container {
  height: 22rem !important;
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .service {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-service { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/service.vue